var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Uma opcao de um seletor, e se e a que esta em vigor. */
let OptionScope = class OptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], OptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], OptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], OptionScope.prototype, "current", void 0);
OptionScope = __decorate([
    Observable
], OptionScope);
export { OptionScope };
let SelectorScope = class SelectorScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.summary = '';
        this.options = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SelectorScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SelectorScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], SelectorScope.prototype, "options", void 0);
SelectorScope = __decorate([
    Observable
], SelectorScope);
export { SelectorScope };
/**
 * Um numero grande com rotulo e icone - o `MetricCard` do painel antigo.
 *
 * Oito deles abrem a tela, em duas linhas de quatro.
 */
let MetricCardScope = class MetricCardScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        /** O icone ao lado do rotulo, pelo nome - ver `lib/lucide-icons.ts` na view. */
        this.icon = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricCardScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricCardScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], MetricCardScope.prototype, "hint", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], MetricCardScope.prototype, "icon", void 0);
MetricCardScope = __decorate([
    Observable
], MetricCardScope);
export { MetricCardScope };
/** Uma barra da distribuicao por faixa de status. */
let StatusBarScope = class StatusBarScope extends Scope {
    constructor() {
        super(...arguments);
        this.category = '';
        this.count = 0;
        this.color = '';
        /**
         * Abrir a lista de quem esta nesta barra.
         *
         * A barra E um conjunto de colaboradores - os que tem a metrica escolhida nesta
         * faixa -, e clicar nela leva a Colaboradores com esse filtro ja aplicado.
         */
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBarScope.prototype, "category", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBarScope.prototype, "count", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], StatusBarScope.prototype, "color", void 0);
StatusBarScope = __decorate([
    Observable
], StatusBarScope);
export { StatusBarScope };
/**
 * Um ponto da serie temporal.
 *
 * `time` e o instante em milissegundos porque o eixo X e NUMERICO: os pontos sao
 * espacados pelo tempo real entre eles, e nao a intervalos iguais. Uma serie com
 * buracos - o paciente que nao mediu por dois dias - mostra o buraco.
 *
 * `high` e `low` so vem preenchidos na PRESSAO, que e a unica metrica com duas
 * curvas: sistolica e diastolica, decodificadas do inteiro unico do backend.
 */
let SeriesPointScope = class SeriesPointScope extends Scope {
    constructor() {
        super(...arguments);
        this.time = 0;
        this.value = 0;
        this.count = 0;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "time", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "high", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "low", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], SeriesPointScope.prototype, "count", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "min", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], SeriesPointScope.prototype, "max", void 0);
SeriesPointScope = __decorate([
    Observable
], SeriesPointScope);
export { SeriesPointScope };
let DashboardScope = class DashboardScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        /** O periodo por extenso, como o backend o descreve. */
        this.periodDescription = '';
        /**
         * Os OITO cartoes, na ordem do desenho do cliente.
         *
         * Uma lista so, e quantas colunas a grade tem e assunto de quem desenha. Eram
         * DUAS ate 23/09/2026 - `cards` e `extraCards` -, porque "Empresas" e "Medicoes"
         * eram adicao do porte e iam numa terceira fileira, para os oito de cima ficarem
         * identicos aos do painel antigo. Com o desenho novo aquela separacao perdeu o
         * motivo: "Empresas" entrou na grade e "Medicoes" saiu da tela.
         *
         * Sete, e nao oito, para quem administra empresa: "Empresas" conta clientes da
         * plataforma, e so o administrador geral o ve.
         */
        this.cards = [];
        /**
         * O titulo do banner roxo.
         *
         * Muda com o papel: quem escolhe empresa le "Seleção de Empresa - Média dos
         * Colaboradores"; os outros leem "Dashboard de Saúde - Média dos Colaboradores".
         */
        this.bannerTitle = '';
        this.metric = 'FREQUENCIA_CARDIACA';
        this.series = [];
        this.statusBars = [];
        /**
         * O grafico AMPLIADO (B-43): ocupa a area do painel e mostra as referencias. Estado da
         * tela, e nao do endereco - um F5 volta ao tamanho normal.
         */
        this.expanded = false;
        /** As faixas do fundo do grafico ampliado: as de status da empresa, para a FC. */
        this.references = [];
        /** A sombra onde esta a maioria das pessoas - percentis 10 e 90 (B-43). */
        this.spread = false;
        this.onToggleExpanded = Scope.ASYNC_ACTION;
    }
    /**
     * Atualizando o que JA esta na tela: trocar de empresa, de periodo ou de indicador.
     *
     * A primeira carga tem a tela de espera inteira; as seguintes mantem o painel
     * anterior desenhado, e sem um aviso ele parecia pronto enquanto a resposta (que
     * demora) nao chegava.
     */
    get refreshing() {
        return this.loading && this.cards.length > 0;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], DashboardScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], DashboardScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DashboardScope.prototype, "periodDescription", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], DashboardScope.prototype, "cards", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DashboardScope.prototype, "bannerTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], DashboardScope.prototype, "companySelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", SelectorScope
    /**
     * O seletor de periodo - scope do `PeriodSelectorPresenter`.
     *
     * Aqui moravam um `SelectorScope` de tres opcoes (Dia, Semana, Mes), uma `date`
     * de ancora e um `today` para o `max` do campo. As tres se resumiam a um
     * intervalo, e e um intervalo que o seletor entrega - com as duas pontas sempre
     * a vista e sete atalhos em vez de tres.
     */
    )
], DashboardScope.prototype, "metricSelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], DashboardScope.prototype, "period", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], DashboardScope.prototype, "metric", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], DashboardScope.prototype, "series", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], DashboardScope.prototype, "statusBars", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DashboardScope.prototype, "expanded", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], DashboardScope.prototype, "sleepGoal", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], DashboardScope.prototype, "references", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], DashboardScope.prototype, "spread", void 0);
DashboardScope = __decorate([
    Observable
], DashboardScope);
export { DashboardScope };
//# sourceMappingURL=dashboard.scope.js.map